import React from 'react';

type DisplayTableRowProps = {
  children?: React.ReactNode;
  className?: string;
  onClick: () => void;
  'data-testid'?: string;
};

export const DisplayTableRow = ({
  children,
  className,
  onClick,
  'data-testid': dataTestId,
}: DisplayTableRowProps) => {
  const classNames = `flex ${className}`;
  return (
    <div className={classNames} onClick={onClick} data-testid={dataTestId}>
      {children}
    </div>
  );
};
